<template>
  <div class="page-about">
    <SectionsPageBanner heading="Privacy Policy" />

    <section class="sections-home-loan-icon-info">
      <div class="container">
        <div class="row">
          <div class="col-12" style="text-align: right;">
            <small>Effective Date: 11 July 2023</small>
          </div>
          <div class="col-12">
            <ElementsHeadingsDefault heading="Introduction" />
            <p>
              This Privacy Policy describes how New Zealand New Homes (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;)
              collects, uses, and protects personal information when you visit and use our website
              (the &quot;Website&quot;). This Privacy Policy applies solely to the information collected by us
              through the Website and does not apply to any other information collected by us
              offline or through other means.
            </p>
            <ElementsHeadingsDefault heading="1. Information We Collect:" />
            <p>
              1.1 Personal Information: We may collect personal information from you when you
              voluntarily provide it to us, such as when you submit an inquiry form, sign up for our
              newsletter, or contact us. The personal information we collect may include your
              name, email address, phone number, and any other information you choose to
              provide.
            </p>
            <p>
              1.2 Automatically Collected Information: When you visit our Website, we may
              automatically collect certain information about your device, browsing actions, and
              patterns. This information may include your IP address, browser type, operating
              system, referring website addresses, pages visited, and other usage information. We
              may use cookies, web beacons, and similar technologies to collect this information.
            </p>
            <ElementsHeadingsDefault heading="2. Use of Information:" />
            <p>
              2.1 We may use the personal information we collect for the following purposes:
              <ul style="padding-left: 28px; list-style: disc;">
                <li>To provide and maintain our services, including advertising new build properties and builders.</li>
                <li>To respond to your inquiries and provide customer support.</li>
                <li>To send you marketing and promotional materials related to new build properties and builders that may be of interest to you, with your consent where required by applicable law.</li>
                <li>To improve and optimize our Website and services.</li>
                <li>To comply with legal obligations and enforce our rights.</li>
              </ul>
            </p>
            <p>
              2.2 We do not share customers&#39; personal information with third parties for their
              marketing purposes. Your personal information will be used solely for the purposes
              stated in this Privacy Policy, unless we obtain your consent or are required by law to
              disclose it.
            </p>
            <ElementsHeadingsDefault heading="3. Security:" />
            <p>
              We take reasonable measures to protect personal information from unauthorized
              access, use, or disclosure. We implement industry-standard security measures to
              safeguard the confidentiality and integrity of personal information. However, please
              note that no method of transmission over the Internet or electronic storage is
              completely secure. Therefore, while we strive to protect your personal information,
              we cannot guarantee its absolute security.
            </p>
            <ElementsHeadingsDefault heading="4. Third-Party Links:" />
            <p>
              Our Website may contain links to third-party websites. Please note that we are not
              responsible for the privacy practices or content of those websites. We encourage
              you to review the privacy policies of any third-party websites you visit.
            </p>
            <ElementsHeadingsDefault heading="5. Your Rights:" />
            <p>
              Subject to applicable laws, you may have the right to request access to, correction,
              or deletion of your personal information. You may also have the right to withdraw
              your consent to the processing of your personal information or to object to certain
              processing activities. To exercise these rights or for any privacy-related inquiries,
              please contact us using the information provided at the end of this Privacy Policy.
            </p>

            <ElementsHeadingsDefault heading="6. Updates to this Privacy Policy:" />
            <p>
              We may update this Privacy Policy from time to time. The updated version will be
              indicated by an updated &quot;Effective Date&quot; at the beginning of this Privacy Policy. We
              encourage you to review this Privacy Policy periodically to stay informed about our
              privacy practices.
            </p>

            <ElementsHeadingsDefault heading="7. Contact Us:" />
            <p>
              If you have any questions or concerns about this Privacy Policy or our privacy
              practices, please contact us at:
              New Zealand New Homes,
              Email: info@newhomes.co.nz
            </p>

            <p style="margin-top: 30px">
              <strong style="font-weight: 700;">Important! </strong>By using our Website, you acknowledge that you have read and understood this
              Privacy Policy and consent to the collection, use, and protection of your personal
              information as described herein.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
// DATA Definitions
//----------------------------------------------------------------------------------------------------------------------
const route = useRoute();

/**
 * @_HEAD Hook
 */
useHead({
  meta: [
    {
      name: 'canonical',
      content: 'https://www.newhomes.co.nz' + route.fullPath,
    },
  ],
});

const title = 'Privacy Policy | New Homes - Understand How We Protect Your Information';
const description = '"New Homes values your privacy. Read our Privacy Policy to understand how we collect, use, protect your information.';
useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: 'https://store.newhomeshub.co.nz/static-assets/new-homes-og-image-v2.jpg',
  twitterCard: 'summary_large_image',
  twitterTitle: title,
  twitterDescription: description,
  twitterImage: 'https://store.newhomeshub.co.nz/static-assets/new-homes-og-image-v2.jpg',
});
</script>

<style lang="scss">
.page-about {
  p {
    padding-bottom: 12px;
    font-weight: 300;
    line-height: 24px;
  }
}
</style>
